import { render, staticRenderFns } from "./_Sorter.vue?vue&type=template&id=35e38f45&"
import script from "./_Sorter.vue?vue&type=script&lang=js&"
export * from "./_Sorter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports